export const SYSTEM_MAINTENANCE_CONSTANTS= {
    PREVIEW_EMAIL: 'PREVIEW_EMAIL',
    PREVIEW_DOCUMENT: 'PREVIEW_DOCUMENT',
    EDIT_EMAIL: 'EDIT_EMAIL',
    EDIT_DOCUMENT: 'EDIT_DOCUMENT',
}